import { VaccineSortOptions, VaccineSortOptionValues } from 'models/SortByOptions';

import { BdColumnHeaderMetadata } from 'components/_common/BdTable/BdTableHeaderRow';

import {
  CaseIncidenceLearnMore,
  ContainmentLearnMore,
  TotalPopulationLearnMore,
} from './ReopeningTrackerTooltipContent';

export const HeaderColumns: BdColumnHeaderMetadata<VaccineSortOptionValues>[] = [
  {
    title: 'Daily case levels',
    tooltipContent: CaseIncidenceLearnMore,
    sortOptions: VaccineSortOptions.localCases,
    sortHeader: 'Sort by:',
    cellWidth: ['100%', '100%', '33%'],
  },
  {
    title: 'Population immunity',
    tooltipContent: TotalPopulationLearnMore,
    sortOptions: VaccineSortOptions.totalAdult,
    sortHeader: 'Sort by:',
    cellWidth: ['100%', '100%', '33%'],
  },
  {
    title: 'Government policy (containment & health)',
    tooltipContent: ContainmentLearnMore,
    sortOptions: VaccineSortOptions.containment,
    sortHeader: 'Sort by:',
    cellWidth: ['100%', '100%', '33%'],
  },
];

export const ImmunityCapRate = 0.9;
